<template>
  <div id="fileUpload">
    <el-upload
      :disabled="loading && showLoading"
      :action="action"
      :headers="headers"
      multiple
      drag
      :data="data"
      :before-upload="beforeUpload"
      :on-success="fnUploadSucess"
      :on-error="handlerError"
      :on-preview="handlePreview"
      :show-file-list="false"
      :on-remove="handleRemove"
      :loading="loading"
      :file-list="fileList"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  data () {
    const url = process.env.VUE_APP_UPLOAD_API
    const Authorization = this.$cookie.get('Authorization')
    return {
      action: url,
      headers: { Authorization },
      fileList: [],
      loading: false
    }
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    types: {
      type: Array
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    limitSize: {
      type: Boolean,
      default: false
    }
  },
  created () {
  },
  methods: {
    handleRemove (file, fileList) {
      this.$emit('removeFile', [file, fileList])
    },
    handlePreview (file, fileList) {
      this.$emit('preview', [file, fileList])
    },
    beforeUpload (file) {
      let canUpload = false
      // 若文件限制格式不为空但是在可上传类型内 或 未指定上传文件 则让他上传
      if (this.types && this.types.length !== 0) {
        for (let i = 0; i < this.types.length; i++) {
          if (file.type === this.types[i]) {
            canUpload = true
          }
        }
      } else {
        canUpload = true
      }
      if (!canUpload) {
        this.$message.error('上传仅支持:' + this.types + '文件')
        return false
      }
      if (this.limitSize) {
        // 限制大小
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
          return false
        }
      }
      this.loading = true
      // 获取时长
      this.getVideoDuration(file)
    },
    getVideoDuration (file) {
      var url = URL.createObjectURL(file)
      var audioElement = new Audio(url)
      var duration
      audioElement.addEventListener('loadedmetadata', () => {
        duration = audioElement.duration // 时长为秒，小数，182.36
        this.$emit('getDuration', duration)
      })
    },

    fnUploadSucess (res, file) {
      this.$emit('fnUploadSucess', file.response.data)
      this.loading = false
      this.fileList = []
    },
    handlerError () {
      this.loading = false
      this.$message.error('上传失败')
      this.$emit('error')
    }
  }
}
</script>

<style scoped lang="scss">
#fileUpload {
  .fileInput {
    display: none;
  }
}
</style>